var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseRoundButton',{attrs:{"icon":"rotate-cw","size":_vm.size,"is-white":"","is-floating":"","disabled":_vm.disabled,"is-loading":_vm.refreshing,"aria-label":_vm.label,"tooltip-text":_vm.hasTooltip ? _vm.label : ''},nativeOn:{"click":function($event){return _vm.onClick.apply(null, arguments)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }